export { Cursos } from './cursos.component'
export * from './cursos.props'
